/**
 * @file        gridConstants.js
 * @description This file contains grid-related constants and utilities used throughout the application.
 * @version     0.1.0
 * @copyright   This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
                is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd.
 * @license     All rights reserved.
 */
// Default pagination value for grid page size
const defaultPaginationValue = 100
export default {
  defaultPaginationValue,
}
